import React from "react";
import "./GoaComingSoon.css";

const GoaComingSoon = () => {
  return (
    <section className="goa-coming">
      <div className="goa-card">
        <h1>Woodland Escape</h1>
        <h2>Goa Resort</h2>

        <p className="desc">
          We are excited to announce that Woodland Escape is expanding to the
          beautiful beaches of <strong>Goa</strong>.
        </p>

        <p className="sub">
          Luxury stays • Nature vibes • Premium hospitality
        </p>

        <div className="divider"></div>

        <div className="contact-box">
          <h4>For Early Enquiries</h4>

          <p>📞 <a href="tel:+919175577266">+91 9175577266</a></p>
          <p>✉️ <a href="mailto:woodlandescape01@gmail.com">
            woodlandescape01@gmail.com
          </a></p>
          <p>📍 Goa, India</p>
        </div>

        <span className="tag">Launching Soon</span>
      </div>
    </section>
  );
};

export default GoaComingSoon;
